import { render, staticRenderFns } from "./CompanyLogoUpload.vue?vue&type=template&id=53018498"
import script from "./CompanyLogoUpload.vue?vue&type=script&lang=js"
export * from "./CompanyLogoUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports